export default __webpack_public_path__ + "assets/5e6801ae3dcd6dbd110b6f8a501b89fa.jpeg";